module.exports = __webpack_public_path__ + "img/exam-img.7f259802.png";